<template>
    <div>
        <input type="hidden" :id="hiddenField.id" :name="hiddenField.name" :required="hiddenField.required"
               v-model="hiddenField.value">
        <div class="bar">
            <div class="md-form">
                <!-- Create a binding between the searchString model and the text field -->
                <i class="fa prefix text-skin--primary" :class="hiddenField.value"></i>
                <input type="text" id="select-icon--search" v-model="searchString" class="form-control">
                <label for="select-icon--search">Search...</label>
            </div>
        </div>
        <div id="select-icon-type--scrollable-container">
            <button v-for="icon in filteredIcons" class="select-icon-type btn btn-md waves-effect waves-light"
                    type="button"
                    :class="{'btn-primary':icon.active,'btn-secondary':!icon.active}"
                    v-on:click="makeActive(icon)">
                <i :class="createIconClass(icon)"></i>
            </button>
        </div>
    </div>
</template>

<script>
    // add imports here

    /**
     * Produces a searchable list of icons to display
     */
    export default {
        props: ['input_field', 'icons_url'],
        mounted() {
            let _this = this;
            //Lets grab icons

            axios.get(_this.icons_url)
                .then(function (response) {
                    for (let key in response.data) {
                        // console.log('key',key);
                        // console.log('response.data[key]',response.data[key]);
                        response.data[key].forEach(function (icon) {
                            _this.icons.push({
                                type: key,
                                img: icon,
                                active: false
                            });
                        })

                        // for (let icon in response.data[key]){
                        //     _this.icons.push({img: icon, active: false});
                        // }
                    }
                });
        },
        data() {
            return {
                selectedIcon: false,
                searchString: "",
                icons: [],
                hiddenField: {
                    name: this.input_field.name,
                    id: this.input_field.id,
                    required: this.input_field.required,
                    value: this.input_field.value
                }
            }
        },
        computed: {
            filteredIcons() {
                let icons_array = this.icons,
                    searchString = this.searchString;

                if (!searchString) {
                    return icons_array;
                }

                searchString = searchString.trim().toLowerCase();

                icons_array = icons_array.filter(function (item) {
                    if (item.img.toLowerCase().indexOf(searchString) !== -1) {
                        return item;
                    }
                });
                return icons_array;
            }
        },
        methods: {
            createIconClass(icon) {
                return `fa ${icon.img}`;
            },
            makeActive: function (icon) {
                // console.log('clicked',icon);
                // de-activate other icons first
                let setIcon = !icon.active;
                for (let key in this.icons) {
                    this.icons[key].active = false;
                }
                this.hiddenField.value = 'fa ' + icon.img;
                icon.active = setIcon;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/IconChooser.vue?492b9b38